module.exports = __webpack_public_path__ + "img/fig_change_setting.307a72cf.png";